"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterTypeGroupState = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.defaultSfilterTypeGroupState = {
    name: 'Type',
    key: SfilterKey_1.SfilterKey.TYPE,
    selected: SfilterTypeGroup_1.SfilterType.RENT,
    options: [
        {
            id: SfilterTypeGroup_1.SfilterType.BUY,
            name: 'Buy',
        },
        {
            id: SfilterTypeGroup_1.SfilterType.RENT,
            name: 'Rent',
        },
    ],
};
